import { Box, Stack, Typography } from "@mui/joy";
import { useRecoilValue } from "recoil";
import { taskListAtom } from "recoil/taskListAtom";
import { theme } from "styles/theme";

export default function MyConcernAndGoal({
  concern,
  goal,
}: {
  concern?: string;
  goal?: string;
}) {
  const taskListState = useRecoilValue(taskListAtom);

  const is1_2_A_done = taskListState.find(
    (element) => element.taskId === "1-2-A"
  )?.lastDoneAt;

  const data = [
    {
      label: "고민",
      text: is1_2_A_done ? concern : null,
      placeholder: "요즈음 나를 괴롭히는 고민은 무엇인가요?",
    },
    {
      label: "목표",
      text: is1_2_A_done ? goal : null,
      placeholder: "내가 만들고 싶은 변화는 무엇인가요?",
    },
  ];

  const someEmpty = data.some(
    ({ text }) => !text || String(text).trim().length === 0
  );
  if (someEmpty) {
    return (
      <Stack
        direction={"column"}
        alignItems="center"
        justifyContent="center"
        sx={{ width: "100%", minHeight: "70vh" }}
      >
        <Typography
          variant={"Body"}
          sx={{
            fontWeight: 500,
            color: theme.vars.palette.Content.Medium,
            textAlign: "center",
            whiteSpace: "pre-line",
          }}
        >
          {"아직 목표를 세우지 않았어요.\n" +
            "코치의 안내에 따라 활동을 진행해주세요."}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack
      spacing={2}
      sx={{
        p: "20px",
        backgroundColor: "white",
        borderRadius: "12px",
      }}
    >
      {data.map(({ label, text, placeholder }, index) => (
        <Box key={index}>
          <Stack spacing={0.5}>
            <Typography
              variant={"Caption"}
              sx={{ color: theme.vars.palette.Content.Highlight, fontWeight: 700 }}
              color="primary"
            >
              {label}
            </Typography>
            <Typography variant={"Body"} sx={{ color: theme.vars.palette.Content.Strong, fontWeight: 500 }}>
              {text || placeholder}
            </Typography>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}
